import React, { useEffect, useMemo, useState } from 'react'
import Slider from 'react-slick';
import BookSlider from '../components/BookSlider';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSettings } from '../context/SettingsContext';
import Loader from '../components/Loader';
import SearchBox from '../components/SearchBox';
import { useProductContext } from '../context/ProductContext';
import { Pagination, Skeleton } from 'antd';

const Home = () => {

    const [banner, setBanner] = useState(null);
    const [pageContent, setPageContent] = useState(null);
    const [testi, setTesti] = useState(null);
    const navigate = useNavigate();

    const { renderHTML, services, settings } = useSettings();

    const getBanner = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}get-content/HomepageBanner`);
            setBanner(res.data.data[0])
        } catch (err) {
            console.error('Error fetching Banner Content:', err);
        }
    }

    const getPageContent = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}get-content/Homepage`);
            setPageContent(res.data.data)
        } catch (err) {
            console.error('Error fetching Page Content:', err);
        }
    }

    const getTesti = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}get-testimonials`);
            setTesti(res.data.data)
        } catch (err) {
            console.error('Error fetching Testimonials:', err);
        }
    }

    useEffect(() => {
        getBanner();
        getPageContent();
        getTesti();
    }, [])

    // var featured_slidder = {
    //     dots: false,
    //     arrows: true,
    //     infinite: false,
    //     speed: 300,
    //     slidesToShow: 4,
    //     slidesToScroll: 4,
    //     responsive: [{
    //         breakpoint: 1100,
    //         settings: {
    //             slidesToShow: 2,
    //             slidesToScroll: 1,
    //             infinite: true,
    //             dots: true
    //         }
    //     },
    //     {
    //         breakpoint: 900,
    //         settings: {
    //             slidesToShow: 2,
    //             slidesToScroll: 1
    //         }
    //     },
    //     {
    //         breakpoint: 500,
    //         settings: {
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //             dots: true
    //         }
    //     }
    //     ]
    // };

    var deal_slidder = {
        dots: false,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: '20%',
        speed: 300,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 1500,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '15%',
                    dots: true
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '10%'
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '5%',
                    dots: true
                }
            }
        ]
    };

    var tstimonial_slidder = {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: true,
        responsive: [{
            breakpoint: 1100,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 500,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
            }
        }
        ]
    };

    const { prod, loading } = useProductContext();

    const [filters, setFilters] = useState({
        brand: "",
        brandCategory: "",
        category: "",
        fuelEfficiency: "",
        season: "",
        wetGrip: "",
        snowGrip: ""
    });
    const [showResults, setShowResults] = useState(false);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [loadingState, setLoadingState] = useState(false);

    // const pageSize = 8;

    // const filteredProducts = useMemo(() => {
    //     if (!showResults) return prod;
    //     return prod.filter((p) => {
    //         const attr = p.Attributes || {};
    //         return (
    //             (!filters.brand || attr.Brand === filters.brand) &&
    //             (!filters.brandCategory || attr.BrandCategory === filters.brandCategory) &&
    //             (!filters.category || attr.Category === filters.category) &&
    //             (!filters.fuelEfficiency || attr.FuelEfficiencyRating === filters.fuelEfficiency) &&
    //             (!filters.season || attr.Season === filters.season) &&
    //             (!filters.wetGrip || attr.WetGripRating === filters.wetGrip) &&
    //             (!filters.snowGrip || (filters.snowGrip === "Yes" ? attr.SnowGrip : !attr.SnowGrip))
    //         );
    //     });
    // }, [prod, filters, showResults]);

    // const startIndex = (currentPage - 1) * pageSize;
    // const currentProducts = filteredProducts.slice(startIndex, startIndex + pageSize);

    // useEffect(() => {
    //     if (showResults) {
    //         const section = document.querySelector('.featured-products');
    //         if (section) {
    //             section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //         }
    //         setLoadingState(true);
    //         const timer = setTimeout(() => {
    //             setLoadingState(false)
    //         }, 500);
    //         return () => clearTimeout(timer);
    //     }
    // }, [filters, currentPage, showResults]);

    // const handleTop = (e) => {
    //     e.preventDefault();
    //     const section = document.querySelector('.product_search_wrpr');
    //     if (section) {
    //         section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //     }
    // }

    // const renderSkeleton = () => (
    //     <div className="container-fluid web-padding">
    //         <div className="row mt-5">
    //             {Array.from({ length: 8 }).map((_, i) => (
    //                 <div className="col-md-3" key={i}>
    //                     <div className="p-3 border rounded-md shadow-sm mb-4">
    //                         <Skeleton.Image active style={{ width: "100%", height: 300, marginBottom: '20px' }} />
    //                         <Skeleton active paragraph={{ rows: 3 }} />
    //                     </div>
    //                 </div>
    //             ))}
    //         </div>
    //     </div>
    // );

    if (banner === null || pageContent === null || testi === null || services === null) {
        return <Loader />
    }

    return (
        <>
            <section className="hero-banner" style={{ backgroundImage: `url(${process.env.REACT_APP_SITE_IMAGES}${banner.image})` }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-7">
                            <div className="hero-sec-left" data-aos="flip-left" data-aos-duration={2000}>
                                <h1>{banner.title}</h1>
                                {renderHTML(banner.details)}
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="hero-sec-right">
                                <img src={`${process.env.REACT_APP_SITE_IMAGES}${banner.image_2}`} alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
                <h2 data-aos="fade-down" data-aos-duration={2000}>Tyres</h2>
            </section>
            <SearchBox filters={filters} setFilters={setFilters} setShowResults={setShowResults} />
            <section className="about-us">
                <div className="container all-section">
                    <div className="row">
                        <div className="col-md-5" data-aos="flip-left" data-aos-duration={2000}>
                            <div className="about-top-left">
                                <h2>{pageContent[0].title}</h2>
                                {renderHTML(pageContent[0].details)}
                            </div>
                        </div>
                        <div className="col-md-7" data-aos="flip-right" data-aos-duration={2000}>
                            <div className="about-top-right">
                                <img src={`${process.env.REACT_APP_SITE_IMAGES}${pageContent[0].image}`} alt={pageContent[0].title} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-5" data-aos="flip-right" data-aos-duration={2000}>
                            <div className="about-bottom-left">
                                <img src={`${process.env.REACT_APP_SITE_IMAGES}${pageContent[1].image}`} alt={pageContent[1].title} />
                            </div>
                        </div>
                        <div className="col-md-7" data-aos="flip-left" data-aos-duration={2000}>
                            <div className="about-bottom-right">
                                <h2>{pageContent[1].title}</h2>
                                {renderHTML(pageContent[1].details)}
                            </div>
                        </div>
                    </div>
                </div>
                <h2 data-aos="fade-down" data-aos-duration={2000}>About Us</h2>
            </section>
            {/* <section className="featured-products">
                <div className="container-fluid web-padding">
                    <div className="row" data-aos="zoom-in-up" data-aos-duration={2000}>
                        <div className="col-md-6 centerCol">
                            <div className="featured-heading text-center">
                                <h2>{pageContent[2].title}</h2>
                                {renderHTML(pageContent[2].details)}
                            </div>
                        </div>
                    </div>
                    {loading || loadingState ? (
                        renderSkeleton()
                    ) : (
                        <div className="container-fluid web-padding">
                            <div className="row mt-5" data-aos="fade-up" data-aos-duration={1000}>
                                {currentProducts.length > 0 ? (
                                    currentProducts.map((tyre, index) => (
                                        <div className="col-md-3" key={index}>
                                            <div className="featured-card mb-4">
                                                <Link to={`/product/${tyre.ProductCode}`}>
                                                    <div className="featured-card-img">
                                                        <img src="/images/feature01.png" alt="tyre" />
                                                    </div>
                                                    <div className="featured-card-wrapper">
                                                        <div className="featured-card-content">
                                                            <h5>{tyre.DescriptionShort}</h5>
                                                            <p>
                                                                Brand: <strong>{tyre.Attributes?.Brand}</strong><br />
                                                                Wet Grip: <strong>{tyre.Attributes?.WetGripRating}</strong><br />
                                                                Fuel Efficiency: <strong>{tyre.Attributes?.FuelEfficiencyRating}</strong>
                                                            </p>
                                                            <h5>£{tyre.VATBondPrice}</h5>
                                                        </div>
                                                        <div className="featured-card-icon">
                                                            <img src="/images/arrow-right.png" alt="arrow" />
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="not_found m-auto">
                                        {filters.brand ||
                                            filters.brandCategory ||
                                            filters.category ||
                                            filters.fuelEfficiency ||
                                            filters.season ||
                                            filters.wetGrip ||
                                            filters.snowGrip ? (
                                            <>No products found for your selection.</>
                                        ) : (
                                            <>
                                                No products found. Please Enter Tyre Size!
                                                <a href="#" onClick={handleTop}>
                                                    <i className="fa-solid fa-arrow-up"></i>
                                                </a>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                            {filteredProducts.length > pageSize && (
                                <div className="row pagination-row">
                                    <div className="col-md-12">
                                        <div className="pagination-wrapper text-center">
                                            <Pagination
                                                current={currentPage}
                                                pageSize={pageSize}
                                                total={filteredProducts.length}
                                                onChange={(page) => setCurrentPage(page)}
                                                showSizeChanger={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </section> */}
            <section className="deal-slidder-wrapper wow">
                <div className="container-fluid all-section">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="services-heading">
                                <div data-aos="flip-left" data-aos-duration={2000}>
                                    <h2>{pageContent[3].title}</h2>
                                    {renderHTML(pageContent[3].details)}
                                </div>
                                <div data-aos="flip-right" data-aos-duration={2000}>
                                    <Link to={`tel:${settings?.phone}`} className="theme-btn">cALL nOW <span><img src="images/arrow-right.png" alt="icon" /></span></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="deal-slidder wow fadeInUpBig" data-wow-duration="2s">
                                <Slider {...deal_slidder}>
                                    {
                                        services.map((serv_item) => {
                                            return <div>
                                                <div className="service-card">
                                                    <div className="service-card-img">
                                                        <img src={`${process.env.REACT_APP_SITE_IMAGES}${serv_item.photo}`} alt={serv_item.title} />
                                                    </div>
                                                    <div className="service-card-content">
                                                        <h3>{serv_item.title}</h3>
                                                        {renderHTML(serv_item.short_details)}
                                                        <Link to={`/service/${serv_item.id}`}>Read more</Link>
                                                    </div>
                                                    <div className="service-card-label">
                                                        <h3>{serv_item.title}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        })
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <secton className="book-sec-wrapper">
                <div className="container-fluid web-padding">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="book-lewft">
                                <h2>{pageContent[5].title}</h2>
                                {renderHTML(pageContent[5].details)}
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="book-sec-wrapper-right">
                                <div className="book-slider-container">
                                    <BookSlider />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h2>Testimonials</h2>
            </secton>
            <section className="what-people-say">
                <div className="container-fluid web-padding">
                    <div className="row wow fadeInUp" data-wow-duration="2s">
                        <div className="col-md-6 centerCol">
                            <div className="what-people-say-heading text-center">
                                <h2>{pageContent[6].title}</h2>
                                {renderHTML(pageContent[6].details)}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="tstimonial-slidder">
                                <Slider {...tstimonial_slidder}>
                                    {
                                        testi.map((testi_item, index) => {
                                            const totalStars = 5;
                                            const filledStars = parseInt(testi_item.stars);
                                            return (
                                                <div key={index}>
                                                    <div className="testimonial-card">
                                                        <div className="testiheading">
                                                            <div className="testi-heading-img">
                                                                <img
                                                                    src={`${process.env.REACT_APP_SITE_IMAGES}${testi_item.image}`}
                                                                    alt={testi_item.name || "testimonial"}
                                                                />
                                                            </div>

                                                            <div className="testi-starts">
                                                                {[...Array(totalStars)].map((_, i) => (
                                                                    <i key={i}
                                                                        className={
                                                                            i < filledStars
                                                                                ? "fa-solid fa-star"
                                                                                : "fa-regular fa-star"
                                                                        }
                                                                    />
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <p>{testi_item.comments}</p>
                                                        <h5>{testi_item.name}</h5>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Home